import { dayjs } from '@/libs/dayjs';

/**
 * Formata um timestamp Unix para uma string de tempo relativo
 * @param unixTimestamp - Timestamp Unix em milliseconds
 * @returns String formatada como "Ontem às 15:07", "Hoje às 10:30", etc.
 */
export const formatRelativeTime = (unixTimestamp: number): string => {
  dayjs.locale('pt-br');

  const date = dayjs(unixTimestamp);
  const now = dayjs();
  const today = now.startOf('day');
  const yesterday = today.subtract(1, 'day');
  const tomorrow = today.add(1, 'day');

  if (date.isSame(today, 'day')) {
    return `Hoje às ${date.format('HH:mm')}`;
  }

  if (date.isSame(yesterday, 'day')) {
    return `Ontem às ${date.format('HH:mm')}`;
  }

  if (date.isSame(tomorrow, 'day')) {
    return `Amanhã às ${date.format('HH:mm')}`;
  }

  if (date.isSame(now, 'week')) {
    return `${date.format('dddd')} às ${date.format('HH:mm')}`;
  }

  if (date.isSame(now, 'year')) {
    return `${date.format('DD/MM')} às ${date.format('HH:mm')}`;
  }

  return `${date.format('DD/MM/YYYY')} às ${date.format('HH:mm')}`;
};

/**
 * Calcula a diferença em dias entre a data atual e a data alvo
 * @param targetDate - Data alvo
 * @returns Número de dias de diferença
 */

export const getDaysDifference = (targetDate: Date): number => {
  const now = new Date().getTime();
  const target = new Date(targetDate).getTime();
  const difference = target - now;
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  return days;
};

/** Verifica se a data alvo está dentro de um número máximo de dias a partir da data atual
 * @param targetDate - Data alvo
 * @param maxDays - Número máximo de dias
 * @returns Verdadeiro se a data alvo estiver dentro do limite, falso caso contrário
 */

export const isWithinDays = (targetDate: Date, maxDays: number): boolean => {
  const days = getDaysDifference(targetDate);
  return days >= 0 && days < maxDays;
};

/**
 * Aguarda um tempo específico em milissegundos
 * @param ms - Tempo em milissegundos
 * @returns Promise que resolve após o tempo especificado
 */
export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
